import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Contact from './Pages/contact'; 
import OurServices from './Pages/ourServices'
import Projects from './Pages/projects'
import Footer from './Components/Footer'

import './App.css';

function App() {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services" element={<OurServices />} />
                <Route path="/projects" element={<Projects />} />
            </Routes>
            <Footer />
        </>
    );
}

export default App;
